module.exports = __webpack_public_path__ + "static/img/monitor_item_image2.64125cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/monitor_item_image2.png
// module id = jEd8
// module chunks = 1